// extracted by mini-css-extract-plugin
export default {"root":"slideTwo_root__yUtwb"};